import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "tariffs" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Стандартные тарифы Spark.kz" })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка тарифов произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadTariffs(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : _createCommentVNode("", true),
      (_ctx.state.tariff && _ctx.state.tariff.length > 0)
        ? (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.IndividualTariffsMain,
                rows: _ctx.IndividualTariffs
              }, {
                td: _withCtx(({ row, column, key }) => [
                  (column.key === 'weight')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(row.weight), 1)
                      ], 64))
                    : (row.is_title)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row.titles[_ctx.getIndexTitle(key)]), 1)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _createElementVNode("p", null, "Цена: " + _toDisplayString(_ctx.state.tariff[_ctx.getIndex(key, 6, true)].minimumPrice), 1),
                          _createElementVNode("p", null, " Цена за кг: " + _toDisplayString(_ctx.state.tariff[_ctx.getIndex(key, 6, true)].cost), 1)
                        ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows"])
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true),
      (_ctx.state.tariff_second && _ctx.state.tariff_second.length > 0)
        ? (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 2,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.StandardParamsColumns,
                rows: _ctx.StandardParamsRows
              }, {
                td: _withCtx(({ row, column, key }) => [
                  (column.key === 'description')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (row.name === 'packPrice')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Терминальная обработка (₸) ")
                            ], 64))
                          : (row.name === 'orderPrice')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" Сбор за оформление заказа (₸) ")
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(`${row.description} ${_ctx.getSign(row.name)}`), 1)
                              ], 64))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.state.tariff_second[_ctx.getParamsIndex(key)].amount), 1)
                      ], 64))
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows"])
            ]),
            _: 1
          }, 8, ["loading"]))
        : _createCommentVNode("", true)
    ])
  ]))
}